import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1930e167"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"2px"} }, "View", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Download ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Download Vendor MasterList ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Download Vendor Template ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Download ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Sync Employee Masterlist ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Upload Vendor Masterlist ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Activate", -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Activate ")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Deactivate", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Deactivate ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Set Permission", -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Set Permission ")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Edit", -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Edit ")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Restore", -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Restore ")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "View", -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" View ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Inactive ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Active ")
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 2 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { key: 2 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { key: 2 }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { key: 2 }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { key: 2 }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { key: 2 }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { key: 2 }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { key: 2 }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { key: 2 }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" Comments ")
const _hoisted_57 = { style: {"margin-top":"20px","color":"gray"} }
const _hoisted_58 = { style: {"margin-top":"10px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_PlusOutlined = _resolveComponent("PlusOutlined")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_CheckOutlined = _resolveComponent("CheckOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_CloseOutlined = _resolveComponent("CloseOutlined")!
  const _component_EditOutlined = _resolveComponent("EditOutlined")!
  const _component_UndoOutlined = _resolveComponent("UndoOutlined")!
  const _component_EyeFilled = _resolveComponent("EyeFilled")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_row, { style: {"margin-bottom":"15px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          class: "search",
          span: "20"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              (_ctx.showFilter)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_1,
                    _createVNode(_component_a_select, {
                      style: {"width":"100px","margin-right":"15px"},
                      options: [
              { label: 'All', value: 'All' },
              { label: 'AP', value: 'AP' },
              { label: 'TCE', value: 'TCE' },
              { label: 'PCRF', value: 'PCRF' },
            ],
                      "show-search": "",
                      filterOption: "filterOption",
                      optionFilterProp: "children"
                    })
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.showSearch)
                ? (_openBlock(), _createBlock(_component_a_input_search, {
                    key: 1,
                    placeholder: "Search",
                    value: _ctx.form.search,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.search) = $event)),
                    class: "search-input",
                    onInput: _cache[1] || (_cache[1] = ($event: any) => {
            _ctx.debounce(() => {
              _ctx.form.search = $event.target.value;
            })
          })
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          span: "4",
          style: {"display":"flex","justify-content":"flex-end"}
        }, {
          default: _withCtx(() => [
            (_ctx.showDownloadButton)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  type: "secondary",
                  class: "create-btn",
                  style: {"margin-right":"2px"},
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('download')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showCreateButton)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 1,
                  type: "primary",
                  class: "create-btn",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('create')))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_PlusOutlined)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(_ctx.addText), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.downloadVendorMasterList)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 2,
                  type: "secondary",
                  class: "create-btn",
                  style: {"margin-right":"2px"},
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('downloadVendorMasterList')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.downloadVendorTemplate)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 3,
                  type: "primary",
                  class: "create-btn",
                  style: {"margin-right":"2px"},
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('downloadVendorTemplate')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.downloadAuditLogs)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 4,
                  type: "primary",
                  class: "create-btn",
                  style: {"margin-right":"2px"},
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('downloadAuditLogs')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.uploadEmployeeMasterList)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 5,
                  type: "primary",
                  class: "create-btn",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('uploadEmployeeMasterList')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.uploadVendorMasterList)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 6,
                  type: "primary",
                  class: "create-btn",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('uploadVendorMasterList')))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_PlusOutlined)
                  ]),
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      size: "small",
      "row-key": _ctx.rowKey,
      pagination: false,
      loading: _ctx.loading,
      columns: _ctx.columns,
      "data-source": _ctx.data,
      style: {"overflow-x":"auto"},
      scroll: _ctx.scrollOptions,
      onChange: _ctx.handleTableChange
    }, {
      action: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_tooltip, { placement: "bottomRight" }, {
              title: _withCtx(() => [
                _hoisted_8
              ]),
              default: _withCtx(() => [
                (_ctx.showActivateButton)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      type: "primary",
                      onClick: ($event: any) => (_ctx.$emit('activate', record)),
                      class: "edit-btn"
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_CheckOutlined)
                      ]),
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_a_tooltip, { placement: "bottomRight" }, {
              title: _withCtx(() => [
                _hoisted_10
              ]),
              default: _withCtx(() => [
                (_ctx.showDeactivateButton)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      type: "primary",
                      onClick: ($event: any) => (_ctx.$emit('inactivate', record)),
                      class: "edit-btn"
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_CloseOutlined)
                      ]),
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_a_tooltip, { placement: "bottomRight" }, {
              title: _withCtx(() => [
                _hoisted_12
              ]),
              default: _withCtx(() => [
                (_ctx.showSetPermissionButton)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      type: "primary",
                      onClick: ($event: any) => (_ctx.$emit('setPermission', record)),
                      class: "create-btn"
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_PlusOutlined)
                      ]),
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_a_tooltip, { placement: "bottomRight" }, {
              title: _withCtx(() => [
                _hoisted_14
              ]),
              default: _withCtx(() => [
                (_ctx.showEditButton)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      type: "primary",
                      onClick: ($event: any) => (_ctx.$emit('edit', record)),
                      class: "edit-btn"
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_EditOutlined)
                      ]),
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_a_tooltip, { placement: "bottomRight" }, {
              title: _withCtx(() => [
                _hoisted_16
              ]),
              default: _withCtx(() => [
                (_ctx.showRestoreButton)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      type: "primary",
                      onClick: ($event: any) => (_ctx.$emit('restore', record)),
                      class: "edit-btn"
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_UndoOutlined)
                      ]),
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_a_tooltip, { placement: "bottomRight" }, {
              title: _withCtx(() => [
                _hoisted_18
              ]),
              default: _withCtx(() => [
                (_ctx.showViewButton)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      type: "primary",
                      onClick: ($event: any) => (_ctx.$emit('view', record)),
                      class: "edit-btn"
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_EyeFilled)
                      ]),
                      default: _withCtx(() => [
                        _hoisted_19
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_a_tooltip, { placement: "bottomRight" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_popconfirm, {
                  title: "Sure to delete?",
                  onConfirm: ($event: any) => (_ctx.$emit('destroy', record))
                }, {
                  default: _withCtx(() => [
                    (_ctx.showDeleteButton)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 0,
                          type: "danger",
                          class: "delete-btn"
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_DeleteOutlined)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["onConfirm"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      activated_status: _withCtx(({ record }) => [
        _createElementVNode("span", null, [
          (!record.is_active)
            ? (_openBlock(), _createBlock(_component_a_tag, {
                key: record.id,
                color: "orange",
                class: "inactive-status-tag"
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 2
              }, 1024))
            : (_openBlock(), _createBlock(_component_a_tag, {
                key: record.id,
                color: "green",
                class: "active-status-tag"
              }, {
                default: _withCtx(() => [
                  _hoisted_21
                ]),
                _: 2
              }, 1024))
        ])
      ]),
      checkbox: _withCtx(({ record }) => [
        _createElementVNode("input", {
          type: "checkbox",
          onClick: ($event: any) => (_ctx.$emit('checked', record.id))
        }, null, 8, _hoisted_22)
      ]),
      employee_full_name: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(record.first_name) + " " + _toDisplayString(record.last_name), 1)
      ]),
      audit_logs_payload: _withCtx(({ record }) => [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(record.payload), (value, name) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: value }, [
              (value !== '' && value !== null)
                ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                    _createElementVNode("div", null, _toDisplayString(name) + " - " + _toDisplayString(value), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ]),
      users_sms: _withCtx(({ record }) => [
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.users, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id
            }, [
              _createVNode(_component_a_space, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.last_name + ", " + item.first_name) + " | ", 1),
                  _createElementVNode("strong", null, _toDisplayString(item.contact_no), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_a_popconfirm, {
                title: "Sure to delete?",
                onConfirm: ($event: any) => (_ctx.$emit('destroy', item.pivot))
              }, {
                default: _withCtx(() => [
                  _hoisted_24,
                  _createVNode(_component_DeleteOutlined)
                ]),
                _: 2
              }, 1032, ["onConfirm"])
            ]))
          }), 128))
        ])
      ]),
      users_email: _withCtx(({ record }) => [
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.users, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id
            }, [
              _createVNode(_component_a_space, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.last_name + ", " + item.first_name) + " | ", 1),
                  _createElementVNode("strong", null, _toDisplayString(item.email), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_a_popconfirm, {
                title: "Sure to delete?",
                onConfirm: ($event: any) => (_ctx.$emit('destroy', item.pivot))
              }, {
                default: _withCtx(() => [
                  _hoisted_25,
                  _createVNode(_component_DeleteOutlined)
                ]),
                _: 2
              }, 1032, ["onConfirm"])
            ]))
          }), 128))
        ])
      ]),
      invoice_number: _withCtx(({ record }) => [
        (record.view == 'AP')
          ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(record.invoice_number), 1))
          : (record.view == 'PCRF' || record.view == 'TCE')
            ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(record.transaction_id), 1))
            : _createCommentVNode("", true)
      ]),
      po_number: _withCtx(({ record }) => [
        (record.view == 'AP')
          ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(record.po_number), 1))
          : _createCommentVNode("", true),
        (record.view != 'AP' && record.coal_payment != null)
          ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(record.coal_payment.po_number), 1))
          : (record.view != 'AP' && record.coal_payment == null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_30))
            : _createCommentVNode("", true)
      ]),
      due_date: _withCtx(({ record }) => [
        (record.view == 'AP')
          ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(record.due_date), 1))
          : (record.view != 'AP' && record.coal_payment != null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(record.coal_payment.due_date), 1))
            : (record.view != 'AP' && record.coal_payment == null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_33))
              : _createCommentVNode("", true)
      ]),
      requestor: _withCtx(({ record }) => [
        (record.view == 'AP')
          ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(record.requestor), 1))
          : (record.view != 'AP' && record.coal_payment != null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(record.coal_payment.requestor), 1))
            : (record.view != 'AP' && record.coal_payment == null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_36))
              : _createCommentVNode("", true)
      ]),
      pv_number: _withCtx(({ record }) => [
        (record.view == 'AP')
          ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(record.pv_number), 1))
          : (record.view != 'AP' && record.coal_payment != null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(record.coal_payment.pv_number), 1))
            : (record.view != 'AP' && record.coal_payment == null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_39))
              : _createCommentVNode("", true)
      ]),
      check_number: _withCtx(({ record }) => [
        (record.view == 'AP')
          ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(record.check_number), 1))
          : (record.view != 'AP' && record.coal_payment != null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(record.coal_payment.check_number), 1))
            : (record.view != 'AP' && record.coal_payment == null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_42))
              : _createCommentVNode("", true)
      ]),
      check_date: _withCtx(({ record }) => [
        (record.view == 'AP')
          ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(record.check_date), 1))
          : (record.view != 'AP' && record.coal_payment != null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(record.coal_payment.check_date), 1))
            : (record.view != 'AP' && record.coal_payment == null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_45))
              : _createCommentVNode("", true)
      ]),
      paid_amount: _withCtx(({ record }) => [
        (record.view == 'AP')
          ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(record.invoice_amount_paid), 1))
          : (record.view != 'AP' && record.coal_payment != null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(record.coal_payment.invoice_amount_paid), 1))
            : (record.view != 'AP' && record.coal_payment == null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_48))
              : _createCommentVNode("", true)
      ]),
      releasing_branch: _withCtx(({ record }) => [
        (record.view == 'AP')
          ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(record.releasing_site), 1))
          : (record.view != 'AP' && record.coal_payment != null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(record.coal_payment.releasing_site), 1))
            : (record.view != 'AP' && record.coal_payment == null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_51))
              : _createCommentVNode("", true)
      ]),
      check_status: _withCtx(({ record }) => [
        (record.view == 'AP')
          ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(record.check_status), 1))
          : (record.view != 'AP' && record.coal_payment != null && record.coal_payment.check_status != null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(record.coal_payment.check_status.name), 1))
            : (record.view != 'AP' && record.coal_payment == null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_54))
              : _createCommentVNode("", true)
      ]),
      comments: _withCtx(({ record }) => [
        (record.view == 'AP')
          ? (_openBlock(), _createElementBlock("span", _hoisted_55, [
              (_ctx.showCommentButton)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "primary",
                    onClick: ($event: any) => (_ctx.$emit('comments', record)),
                    class: "edit-btn"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_56
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["row-key", "loading", "columns", "data-source", "scroll", "onChange"]),
    (_ctx.data.length && _ctx.showPagination)
      ? (_openBlock(), _createBlock(_component_a_row, {
          key: 0,
          style: {"margin":"15px 15px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              class: "search",
              span: "24"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.pagination.from) + " - " + _toDisplayString(_ctx.pagination.to) + " of " + _toDisplayString(_ctx.pagination.total), 1)
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createVNode(_component_a_pagination, {
                    size: "small",
                    total: _ctx.pagination.total,
                    onChange: _ctx.onChange,
                    onShowSizeChange: _ctx.onShowLimit,
                    current: _ctx.form.page
                  }, null, 8, ["total", "onChange", "onShowSizeChange", "current"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}